import { supportedLanguages } from "../components/LanguageSelect/languageSelectConfig";

export const getLocale = (language = "en") => {
  const languageSetting = supportedLanguages.find((lang) => lang.value === language);

  return languageSetting?.locale || "en-UK";
};
